import React, { useState } from "react";
import { Image as ChakraImage, ImageProps, Skeleton } from "@chakra-ui/react";

interface Props extends ImageProps {
  shouldUseSkeleton?: boolean;
}

const Image = (props: Props) => {
  const { w, h, borderRadius } = props;
  const { shouldUseSkeleton, ...imageProps } = props;
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && shouldUseSkeleton && (
        <Skeleton w={w} minW={w} h={h} borderRadius={borderRadius} />
      )}
      <ChakraImage
        data-testid="chakra-image"
        // display={isLoading ? "none" : "block"}
        visibility={isLoading ? "hidden" : "visible"}
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
        {...imageProps}
      />
    </>
  );
};

export default Image;
